module.exports = __webpack_public_path__ + "static/media/background2 copy.1137bb5c.png";